module.exports = __webpack_public_path__ + "img/logo_unesco.ecf10c66.png";